// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","slider":"slider_slider__5zkRA","imgWrapper":"slider_imgWrapper__QHjtU","image":"slider_image__XqTff"};